module.exports = __webpack_public_path__ + "img/slider1.c3a5a930.jpg";